import React from 'react';
import './ChartContainer.css';

interface ChartContainerProps {
  title: string;
  subtitle?: string;
  isLoading?: boolean;
  error?: string | null;
  isEmpty?: boolean;
  emptyMessage?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

const ChartContainer: React.FC<ChartContainerProps> = ({
  title,
  subtitle,
  isLoading = false,
  error = null,
  isEmpty = false,
  emptyMessage = 'No data available',
  children,
  actions,
  className = '',
}) => {
  return (
    <div className={`chart-container ${className}`}>
      <div className="chart-header">
        <div className="chart-header-text">
          <h3 className="chart-title">{title}</h3>
          {subtitle && <p className="chart-subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="chart-actions">{actions}</div>}
      </div>
      <div className="chart-body">
        {isLoading ? (
          <div className="chart-loading">
            <div className="chart-spinner" />
            <p>Loading...</p>
          </div>
        ) : error ? (
          <div className="chart-error">
            <p>{error}</p>
          </div>
        ) : isEmpty ? (
          <div className="chart-empty">
            <p>{emptyMessage}</p>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default ChartContainer;
